import {
    FeatureApiType,
    FiFeatureApiType,
} from '@treasury/domain/backoffice/services/company/types/product-feature.enum';

export function mapProductFeatureTypeToPrettyProductFeature(
    featureType: FeatureApiType | FiFeatureApiType
): string {
    switch (featureType) {
        case FiFeatureApiType.AccountRecon:
        case FeatureApiType.AccountRecon:
            return PrettyFeatureType.AccountRecon;
        case FiFeatureApiType.ACH:
        case FeatureApiType.ACH:
            return PrettyFeatureType.ACH;
        case FiFeatureApiType.Agiletics:
        case FeatureApiType.Agiletics:
            return PrettyFeatureType.AgileticsWebEscrow;
        case FiFeatureApiType.BillPay:
        case FeatureApiType.BillPay:
            return PrettyFeatureType.BillPay;
        case FiFeatureApiType.ElectronicDocuments:
        case FeatureApiType.ElectronicDocuments:
            return PrettyFeatureType.ElectronicStatementInteractive;
        case FiFeatureApiType.ForeignCurrencyWire:
        case FeatureApiType.ForeignCurrencyWire:
            return PrettyFeatureType.ForeignCurrencyWire;
        case FiFeatureApiType.PositivePay:
        case FeatureApiType.PositivePay:
            return PrettyFeatureType.PositivePay;
        case FiFeatureApiType.RemoteDeposit:
        case FeatureApiType.RemoteDeposit:
            return PrettyFeatureType.RemoteDeposit;
        case FiFeatureApiType.Reporting:
        case FeatureApiType.Reporting:
            return PrettyFeatureType.Reporting;
        case FiFeatureApiType.StopPayment:
        case FeatureApiType.StopPayment:
            return PrettyFeatureType.StopPayment;
        case FiFeatureApiType.Transfer:
        case FeatureApiType.Transfer:
            return PrettyFeatureType.Transfer;
        case FiFeatureApiType.Wausau:
        case FeatureApiType.Wausau:
            return PrettyFeatureType.WausauEStatement;
        case FiFeatureApiType.Wire:
        case FeatureApiType.Wire:
            return PrettyFeatureType.Wire;
        case FiFeatureApiType.AmpliFiLoyalty:
        case FeatureApiType.AmpliFiLoyalty:
            return PrettyFeatureType.AmpliFiLoyalty;
        case FiFeatureApiType.CentrixSso:
        case FeatureApiType.CentrixSso:
            return PrettyFeatureType.CentrixSso;
        default:
            throw new Error(`Unhandled feature type: ${featureType}`);
    }
}

export enum PrettyFeatureType {
    AccountRecon = 'accountreconciliation',
    ACH = 'ach',
    AgileticsWebEscrow = 'agiletics',
    BillPay = 'billpay',
    ElectronicStatementInteractive = 'esi',
    ForeignCurrencyWire = 'foreign',
    PositivePay = 'positivepay',
    RemoteDeposit = 'rdc',
    Reporting = 'reporting',
    StopPayment = 'stoppayment',
    Transfer = 'transfer',
    WausauEStatement = 'wausau',
    Wire = 'wires',
    AmpliFiLoyalty = 'amplifi',
    CentrixSso = 'centrix',
}
